import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { isString } from 'lodash';
import moment from 'moment';
import KenColors from '../../utils/kenColors';

const useStyles = makeStyles({
  root: {
    width: '100% !important',
    marginTop: '5px',
    minWidth: '200px !important',
  },
  helperText: {
    marginLeft: 0,
    fontSize: '12px',
    color: KenColors.red2,
  },
});

const StyledTextField = styled(TextField)(({ error, border, theme, customMargin, height }) => ({
  fontSize: '12px',
  '& .MuiOutlinedInput-root': {
    fontSize: '14px',
    fontWeight: '500',
    height: height ? `${height} !important` : 'auto',
    color: KenColors.ClientGrey,
    margin: customMargin ? '4px 0px' : '0px',
    '@media (max-width: 1440px)': {
      height: height ? `45px !important` : 'auto',
      borderRadius: '3px',
    },
    input: {
      '&::placeholder': {
        fontWeight: '500',
        color: KenColors.ClientGrey,
      },
    },
    '& fieldset': {
      border: border ? '0.5px solid' : '2px solid',
      borderColor: theme.palette.KenColors.grey,
    },
    '&:hover fieldset': {
      border: border ? '0.5px solid' : '2px solid',
      borderColor: error ? theme.palette.KenColors.statusRed : theme.palette.KenColors.grey,
    },
    '&.Mui-focused fieldset': {
      border: border ? '0.5px solid' : '2px solid',
      borderColor: error ? theme.palette.KenColors.statusRed : theme.palette.KenColors.grey,
    },
  },
}));

export default function KenTextField(props) {
  const {
    FormHelperTextProps,
    InputLabelProps,
    inputProps,
    InputProps,
    className,
    children,
    disableKeyDown,
    minDate,
    maxDate,
    name,
    value,
    remaining = false,
    maxCharacters,
    dateType = 'year',
    withValue,
    error,
    onKeyDown,
    helperText,
  } = props;
  const classes = useStyles();
  console.log(onKeyDown, "iuy4t8745t");

  return (
    <StyledTextField
      className={`${className}`}
      classes={{ root: classes.root }}
      InputLabelProps={{ shrink: false, ...InputLabelProps }}
      inputProps={{
        ...inputProps,
        style: { height: 'auto' },
      }}
      InputProps={{
        components: 'p',
        className: classes.inputStyles,
        ...InputProps,
        inputProps: {
          min:
            minDate &&
            minDate !== null &&
            (minDate === true
              ? moment().format('YYYY-MM-DD')
              : isString(minDate)
                ? minDate
                : withValue
                  ? moment(value).subtract(Number(minDate), dateType).format('YYYY-MM-DD')
                  : moment().subtract(Number(minDate), dateType).format('YYYY-MM-DD')),
          max:
            maxDate &&
            maxDate !== null &&
            (maxDate === true
              ? moment().format('YYYY-MM-DD')
              : withValue
                ? moment(value).add(Number(maxDate), dateType).format('YYYY-MM-DD')
                : moment().add(Number(maxDate), dateType).format('YYYY-MM-DD')),
          'data-testid': `test-${name}`,
        },
      }}
      FormHelperTextProps={{
        className: classes.helperText,
        ...FormHelperTextProps,
      }}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              maxHeight: '300px',
            },
          },
        },
      }}
      {...props}
      onKeyDown={(e) => {
        onKeyDown ? onKeyDown(e) : disableKeyDown && e.preventDefault();
      }}
      label=""
      error={error}
      helperText={error ? helperText : remaining === true && <p style={{ color: KenColors.neutral400, marginTop: '-2px' }}>Remaining Characters: {maxCharacters - (value?.length || 0)}</p>}
    >
      {children}
    </StyledTextField>
  );
}
